// extracted by mini-css-extract-plugin
export default {"button":"Bk-z","reviewSort":"Ck-z"};